<template>
  <div>
    <div class="processed-list-con" @click="handleToPage(item)">
      <div :class=" hasPerms(item.authorityFlag) ? '' : 'no-permission-icon'">
        <div class="processed-image" :class="'coloricon' + item.menuTag">
          <i class="icon iconfont" :class="item.icon"></i>
        </div>
      </div>
      <div class="processed-count">
        <div class="processed-desc">{{ item.number }}</div>
        <div class="processed-title">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { hasPermission } from '@/permission/index.js'

export default {
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleToPage (item) {
      if (!this.hasPerms(item.authorityFlag)) {
        return this.$message.warning('暂无操作权限')
      }
      const query = item.status ? { status: item.status } : null
      if (item.path) {
        this.$router.push(
          {
            path: item.path,
            query
          }
        )
      }
    },
    hasPerms: function (flag) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(flag) // & !this.disabled
    }
  }
}
</script>
